import { Link } from "react-router-dom";
import { useNotificheConteggio } from "../../hooks/useNotifiche";

/**
 * NotificheBell — campanella in header.
 *
 * Click → naviga direttamente a /notifiche (pagina dedicata).
 * Mostra badge con numero notifiche non lette.
 */
export function NotificheBell() {
  const { data: conteggio } = useNotificheConteggio();
  const nonLette = conteggio?.non_lette ?? 0;

  return (
    <Link
      to="/notifiche"
      aria-label={`Notifiche${nonLette > 0 ? ` (${nonLette} non lette)` : ""}`}
      className="relative p-2 rounded-lg hover:bg-accent/10 transition-colors"
    >
      <span className="text-xl">🔔</span>
      {nonLette > 0 && (
        <span className="absolute -top-1 -right-1 min-w-[20px] h-5 px-1 flex items-center justify-center rounded-full bg-danger text-white text-xs font-bold">
          {nonLette > 99 ? "99+" : nonLette}
        </span>
      )}
    </Link>
  );
}
